import api from './api';

/**
 * GSF Car Parts API service
 */
export const gsfService = {
  /**
   * Check if GSF API is configured
   * @returns {Promise<{configured: boolean}>}
   */
  checkStatus: async () => {
    const response = await api.get('/v1/gsf/status/');
    return response.data;
  },

  /**
   * Get all available part types for dropdown
   * @returns {Promise<{part_types: Array<{id: string, name: string, category: string}>}>}
   */
  getPartTypes: async () => {
    const response = await api.get('/v1/gsf/part-types/');
    return response.data;
  },

  /**
   * Search for parts by vehicle and part type
   * @param {string} registration - Vehicle registration
   * @param {string} partType - Part type ID/name
   * @returns {Promise<{registration: string, part_type: string, parts: Array, count: number}>}
   */
  searchParts: async (registration, partType) => {
    const response = await api.get('/v1/gsf/search/', {
      params: {
        registration,
        part_type: partType,
      },
    });
    return response.data;
  },

  /**
   * Retry a failed GSF order
   * @param {number} jobRequestId - Job request ID
   * @returns {Promise<{success: boolean, message: string}>}
   */
  retryOrder: async (jobRequestId) => {
    const response = await api.post(`/v1/gsf/retry/${jobRequestId}/`);
    return response.data;
  },

  /**
   * Mark a GSF order as manually ordered
   * @param {number} jobRequestId - Job request ID
   * @param {string} confirmationNumber - Optional confirmation number
   * @returns {Promise<{success: boolean, message: string}>}
   */
  markManuallyOrdered: async (jobRequestId, confirmationNumber = '') => {
    const response = await api.post(`/v1/gsf/mark-manual/${jobRequestId}/`, {
      confirmation_number: confirmationNumber,
    });
    return response.data;
  },
};

export default gsfService;
